var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { getValueOfNestedObject } from '@/utils';
import { Controller, useFieldArray, } from 'react-hook-form';
import { Checkbox } from './checkbox';
import { DropDownField } from './drop-down-field';
import FieldGroup from './field-group';
import { TextAreaField } from './text-area-field';
import { TextInputField } from './text-input-field';
import { Button } from '../ui';
var ArrayFormField = function (_a) {
    var control = _a.control, errors = _a.errors, register = _a.register, field = _a.field;
    var _b = useFieldArray({
        name: field.name,
        control: control,
    }), fields = _b.fields, append = _b.append, remove = _b.remove;
    return (_jsxs("div", { className: 'w-full', children: [_jsx(Button, { variant: 'outline', size: 'sm', type: 'button', onClick: function () { return append({}); }, children: "Add" }), fields === null || fields === void 0 ? void 0 : fields.map(function (item, index) {
                var _a;
                return (_jsxs(FieldGroup, { children: [(_a = field.itemTemplate.fields) === null || _a === void 0 ? void 0 : _a.map(function (arrayField) { return (_jsx(DynamicFormField, { control: control, errors: errors, field: __assign(__assign({}, arrayField), { name: "".concat(field.name, "[").concat(index, "].").concat(arrayField.name) }), register: register }, arrayField.name)); }), _jsx(Button, { variant: 'dangerSecondary', size: 'sm', type: 'button', onClick: function () { return remove(index); }, children: "Remove" })] }, item.id));
            })] }));
};
export var DynamicFormField = function (_a) {
    var control = _a.control, errors = _a.errors, field = _a.field, register = _a.register;
    var renderField = function () {
        var _a;
        var error = getValueOfNestedObject(errors, field.name);
        switch (field.type) {
            case 'text':
            case 'email':
            case 'password':
            case 'tel':
            case 'url':
            case 'date':
                return (_jsx(TextInputField, __assign({ label: field.label, error: error === null || error === void 0 ? void 0 : error.message, isRequired: !!field.required, type: field.type }, register(field.name, { required: field.required }), { hasError: !!(error === null || error === void 0 ? void 0 : error.message), placeholder: field.placeholder })));
            case 'number':
                return (_jsx(TextInputField, __assign({ label: field.label, error: error === null || error === void 0 ? void 0 : error.message, isRequired: !!field.required, type: 'number' }, register(field.name, {
                    required: field.required,
                    valueAsNumber: true,
                }), { hasError: !!(error === null || error === void 0 ? void 0 : error.message), placeholder: field.placeholder })));
            case 'select':
            case 'multiselect':
                return (_jsx(Controller, { name: field.name, control: control, render: function (_a) {
                        var _b = _a.field, onChange = _b.onChange, value = _b.value, ref = _b.ref;
                        return (_jsx(DropDownField, { multiSelect: field.type === 'multiselect' ? true : false, options: Array.isArray(field.options) ? field.options : [], selectedOptions: value, onChange: onChange, fieldRef: ref, label: field.label, error: error === null || error === void 0 ? void 0 : error.message, isRequired: !!(error === null || error === void 0 ? void 0 : error.message), placeholder: field.placeholder }));
                    } }));
            case 'boolean':
                return (_jsx(Checkbox, __assign({ label: field.label, error: error === null || error === void 0 ? void 0 : error.message, isRequired: !!field.required }, register(field.name, { required: field.required }))));
            case 'textarea':
                return (_jsx(TextAreaField, __assign({ label: field.label, error: error === null || error === void 0 ? void 0 : error.message, isRequired: !!field.required }, register(field.name, { required: field.required }), { rows: field.rows || 3, maxLength: field.maxLength, placeholder: field.placeholder, defaultValue: typeof field.defaultValue === 'boolean' ? '' : field.defaultValue || '' })));
            case 'section':
            case 'location':
            case 'object':
                return (_jsx(FieldGroup, { label: field.label, children: (_a = field.fields) === null || _a === void 0 ? void 0 : _a.map(function (sectionField) { return (_jsx(DynamicFormField, { control: control, errors: errors, field: __assign(__assign({}, sectionField), { name: "".concat(field.name, ".").concat(sectionField.name) }), register: register }, sectionField.name)); }) }));
            case 'array':
                return (_jsx(FieldGroup, { label: field.label, children: _jsx(ArrayFormField, { control: control, register: register, errors: errors, field: field }) }));
            default:
                return null;
        }
    };
    return renderField();
};
